import { Box, Button, Typography } from "@mui/material";
import { FileDropzone } from "../../components/core/file-dropzone";
import { StorageProvider } from "../../components/TaxShield/file-storage/storage-context";
import { StorageView } from "../../components/TaxShield/file-storage/storage-view";
import Loading from "../Loading";
import DragDropFiles from "../../components/DragDropFiles";
import { useNavigate } from "react-router-dom";
import { paths } from "../../paths";
import { useState } from "react";
import { FaTrashAlt } from "@react-icons/all-files/fa/FaTrashAlt";
import { SetS3Config } from "../../awsClientConfig";
import { userAccountData, userProfileData } from "../profileInfo";
import { v4 as uuidv4 } from "uuid";
import { Storage } from "aws-amplify";
import Message from "../../components/Message";


const UploadTaxReturn = () => {

    const navigate = useNavigate();
    const [buttonDisable, setButtonDisable] = useState(false);
    const [file, setFile] = useState<any>();
    const [showMessage, setShowMessage] = useState({show: false, type: ""});
 
    const handleChange = async (fileObj: any) => {
      const extension = getExtension(fileObj.name);
      const ispdf = isPdf(fileObj.name);
      let contentType = ispdf ? "application/pdf" : "image/png";
      SetS3Config(
        `documents-${process.env.REACT_APP_MODE}-optima-financial-group`,
        "public"
      );
  
      const profileId = await userProfileData();
      const accountId = await userAccountData();
      const uuid = uuidv4();
  
      try {
        await Storage.put(
          `Accounts/${accountId}/Profiles/${profileId}/Identifications/${uuid}.${extension}`,
          fileObj,
          {
            contentType: contentType, // contentType is optional
            customPrefix: { public: "" },
            tagging: "ExternalClearance=Profile",
          }
        ).then((res) => {
          loadSingleImage(res);
        });
      } catch (error) {
        console.log("Error uploading file: ", error);
      }
    }
    function getExtension(filename: any) {
      var parts = filename.split(".");
      return parts[parts.length - 1];
    }
  
    function isPdf(filename: any) {
      if(filename){
        var ext = getExtension(filename);
        switch (ext.toLowerCase()) {
          case "pdf":
            return true;
        }
      }
      return false;
    }

    const loadSingleImage = async (url: any) => {
      const ispdf = isPdf(url.key);
      let contentType = ispdf ? "application/pdf" : "image/png";
      const imageData: any = await Storage.get(url.key, {
        level: "public",
        contentType: contentType,
        customPrefix: { public: "" },
      });
      let imageObj = {
        src: imageData,
        key: url.key,
      };
  
      setFile(imageObj);
    };

    const handleRemoveImage = async (imageUrl: string) => {
      SetS3Config(
        `documents-${process.env.REACT_APP_MODE}-optima-financial-group`,
        "public"
      );
  
      try {
        await Storage.remove(imageUrl, {
          // contentType: "image/png", // contentType is optional
          customPrefix: { public: "" },
          level: "public",
          // tagging: "ExternalClearance=Profile",
        }).then((res) => {
          setFile(null)
        });
      } catch (error) {
        console.log("Error uploading file: ", error);
      }
    }

    const fileUploadHandler = async () => {
      setButtonDisable(true);
      setShowMessage({show:true, type:"success"});
      setTimeout(() => {
        setMessageToInitialState();
        navigate(paths.dashboard.taxShield.reports);
      }, 5000);
    }

    const setMessageToInitialState = () => {
      setShowMessage({show: false, type: ""});
    }

    const notNowHandler = async () => {
      if(file && file.key)
        await handleRemoveImage(file.key);
      navigate(paths.dashboard.taxShield.reports);
    }

    return (
        <Box
            sx={{
            alignItems: "flex-center",
            p: { xs: 2, md: 6, lg: 4 },
            m: { xs: 2, md: 6, lg: 4 },
            }}
        >
        <Box className="tax-return-upload-card-outer-card">
            <Box className="tax-return-upload-card">
                <Box>
                    <Typography variant="h5" sx={{color: '#0a579b'}}>{'Your Tax Return Upload'}</Typography>
                    <Typography variant="body2" sx={{mt:2}}>{'Please upload a copy of your filed tax return.'}</Typography>
                    <Typography variant="body2" sx={{mt:2}}>{'Please check the following to make sure your document can be processed:'}</Typography>
                    <ul>
                    <li><Typography variant="body2" sx={{mt: 2}}>{'The image is clear and not blurry'}</Typography></li>
                    <li><Typography variant="body2">{'All information is visible'}</Typography></li>
                    <li><Typography variant="body2">{'The document is not captured at an angle'}</Typography></li>
                    </ul>
                </Box>
                <DragDropFiles onChange={handleChange} />
                {showMessage.show && <>
                    {showMessage.type === 'success'?
                    <Message
                      type="success"
                      message="Upload Successful"
                    ></Message>:<Message
                    type="error"
                    message="Upload unsuccessful. Please try again."
                  ></Message>}
                  </>
                }
                {file && 
                <div>
                  <div className="col px-lg-2 d-flex py-2">
                    <div
                      style={{
                        width: 215,
                        height: 142,
                        objectFit: "cover",
                        borderWidth: 2,
                        borderColor: "#ddd",
                        borderStyle: "solid",
                        textAlign: "center",
                        marginLeft: 10,
                      }}
                    >
                      {isPdf(file?.key) ? (
                        <iframe
                          src={file?.src}
                          title="app-logo"
                          style={{
                            width: 212,
                            height: 138,
                            objectFit: "cover",
                            borderWidth: 2,
                            borderColor: "#ddd",
                          }}
                        />
                      ) : (
                        <img
                          src={file?.src}
                          alt="app-logo"
                          style={{
                            width: 212,
                            height: 138,
                            objectFit: "cover",
                            borderWidth: 2,
                            borderColor: "#ddd",
                          }}
                        />
                      )}
                      <a
                        href="/"
                        className="fw-bold text-decoration-none mt-2 delete-icon"
                        onClick={(e) => {
                          e.preventDefault();
                          handleRemoveImage(file?.key);
                        }}
                      >
                        <FaTrashAlt
                          className="me-1"
                          onClick={() => handleRemoveImage(file?.key)}
                        />
                        Delete
                      </a>
                    </div>
                  </div>
                </div>
                }
                <div className="d-flex justify-content-between mt-5 align-items-center">
                  <span
                    className="letsdolater"
                    onClick={notNowHandler}
                  >
                    Not Now
                  </span>
                  <button
                    disabled={file?buttonDisable:true}
                    className={
                      file ? "btn-continue": "btn-disable"
                    }
                    onClick={fileUploadHandler}
                  >
                    Upload
                  </button>
                </div>
            </Box> 
        </Box>
        </Box>
    )
}

export default UploadTaxReturn;